import {
  AnalyticsConfigApiFields,
  DeliveryOptimizationConfigApiFields,
  DeliveryOptimizationSetting,
  OrderingConfigApiFields,
  PreferencesModalConfigApiFields,
  ReceiptConfigApiFields,
  TiersConfigApiFields,
  UnavailableItemVisibilitySetting,
} from 'models/Config'
import {
  AxiosAction,
  FailureAction,
  SuccessAction,
} from 'redux-axios-middleware'

export const GET_RECEIPT_CONFIG = 'config/GET_RECEIPT_CONFIG'
export const GET_RECEIPT_CONFIG_FAIL = 'config/GET_RECEIPT_CONFIG_FAIL'
export const GET_RECEIPT_CONFIG_SUCCESS = 'config/GET_RECEIPT_CONFIG_SUCCESS'

export const UPDATE_RECEIPT_CONFIG = 'config/UPDATE_RECEIPT_CONFIG'
export const UPDATE_RECEIPT_CONFIG_SUCCESS =
  'config/UPDATE_RECEIPT_CONFIG_SUCCESS'
export const UPDATE_RECEIPT_CONFIG_FAIL = 'config/UPDATE_RECEIPT_CONFIG_FAIL'

export const GET_TIERS_CONFIG = 'config/GET_TIERS_CONFIG'
export const GET_TIERS_CONFIG_FAIL = 'config/GET_TIERS_CONFIG_FAIL'
export const GET_TIERS_CONFIG_SUCCESS = 'config/GET_TIERS_CONFIG_SUCCESS'

export const GET_ANALYTICS_CONFIG = 'config/GET_ANALYTICS_CONFIG'
export const GET_ANALYTICS_CONFIG_SUCCESS =
  'config/GET_ANALYTICS_CONFIG_SUCCESS'
export const GET_ANALYTICS_CONFIG_FAIL = 'config/GET_ANALYTICS_CONFIG_FAIL'

export const UPDATE_ANALYTICS_CONFIG = 'config/UPDATE_ANALYTICS_CONFIG'
export const UPDATE_ANALYTICS_CONFIG_SUCCESS =
  'config/UPDATE_ANALYTICS_CONFIG_SUCCESS'
export const UPDATE_ANALYTICS_CONFIG_FAIL =
  'config/UPDATE_ANALYTICS_CONFIG_FAIL'

export const GET_PREFERENCES_MODAL_CONFIG =
  'config/GET_PREFERENCES_MODAL_CONFIG'
export const GET_PREFERENCES_MODAL_CONFIG_SUCCESS =
  'config/GET_PREFERENCES_MODAL_CONFIG_SUCCESS'
export const GET_PREFERENCES_MODAL_CONFIG_FAIL =
  'config/GET_PREFERENCES_MODAL_CONFIG_FAIL'

export const UPDATE_PREFERENCES_MODAL_CONFIG =
  'config/UPDATE_PREFERENCES_MODAL_CONFIG'
export const UPDATE_PREFERENCES_MODAL_CONFIG_SUCCESS =
  'config/UPDATE_PREFERENCES_MODAL_CONFIG_SUCCESS'
export const UPDATE_PREFERENCES_MODAL_CONFIG_FAIL =
  'config/UPDATE_PREFERENCES_MODAL_CONFIG_FAIL'

export const GET_DELIVERY_OPTIMIZATION_CONFIG =
  'config/GET_DELIVERY_OPTIMIZATION_CONFIG'
export const GET_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS =
  'config/GET_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS'
export const GET_DELIVERY_OPTIMIZATION_CONFIG_FAIL =
  'config/GET_DELIVERY_OPTIMIZATION_CONFIG_FAIL'

export const UPDATE_DELIVERY_OPTIMIZATION_CONFIG =
  'config/UPDATE_DELIVERY_OPTIMIZATION_CONFIG'
export const UPDATE_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS =
  'config/UPDATE_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS'
export const UPDATE_DELIVERY_OPTIMIZATION_CONFIG_FAIL =
  'config/UPDATE_DELIVERY_OPTIMIZATION_CONFIG_FAIL'

export const GET_ORDERING_MERCHANT_CONFIG =
  'config/GET_ORDERING_MERCHANT_CONFIG'
export const GET_ORDERING_MERCHANT_CONFIG_SUCCESS =
  'config/GET_ORDERING_MERCHANT_CONFIG_SUCCESS'
export const GET_ORDERING_MERCHANT_CONFIG_FAIL =
  'config/GET_ORDERING_MERCHANT_CONFIG_FAIL'

export const UPDATE_ORDERING_MERCHANT_CONFIG =
  'config/UPDATE_ORDERING_MERCHANT_CONFIG'
export const UPDATE_ORDERING_MERCHANT_CONFIG_SUCCESS =
  'config/UPDATE_ORDERING_MERCHANT_CONFIG_SUCCESS'
export const UPDATE_ORDERING_MERCHANT_CONFIG_FAIL =
  'config/UPDATE_ORDERING_MERCHANT_CONFIG_FAIL'

export type GetReceiptConfigResolvedAction =
  | FailureAction<typeof GET_RECEIPT_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_RECEIPT_CONFIG_SUCCESS,
      { receipt_config: ReceiptConfigApiFields }
    >

export type GetTiersConfigResolvedAction =
  | FailureAction<typeof GET_TIERS_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_TIERS_CONFIG_SUCCESS,
      { tiers_config: TiersConfigApiFields | null }
    >

export type GetAnalyticsResolvedAction =
  | FailureAction<typeof GET_ANALYTICS_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_ANALYTICS_CONFIG_SUCCESS,
      { ordering_analytics: AnalyticsConfigApiFields }
    >

export type UpdateAnalyticsResolvedAction =
  | AxiosAction<typeof UPDATE_ANALYTICS_CONFIG>
  | FailureAction<typeof UPDATE_ANALYTICS_CONFIG_FAIL>
  | SuccessAction<
      typeof UPDATE_ANALYTICS_CONFIG_SUCCESS,
      { ordering_analytics: AnalyticsConfigApiFields }
    >

export type GetPreferencesModalResolvedAction =
  | FailureAction<typeof GET_PREFERENCES_MODAL_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_PREFERENCES_MODAL_CONFIG_SUCCESS,
      { preferences_modal: PreferencesModalConfigApiFields }
    >

export type UpdatePreferencesModalResolvedAction =
  | AxiosAction<typeof UPDATE_PREFERENCES_MODAL_CONFIG>
  | FailureAction<typeof UPDATE_PREFERENCES_MODAL_CONFIG_FAIL>
  | SuccessAction<
      typeof UPDATE_PREFERENCES_MODAL_CONFIG_SUCCESS,
      { preferences_modal: PreferencesModalConfigApiFields }
    >

export type GetDeliveryOptimizationResolvedAction =
  | FailureAction<typeof GET_DELIVERY_OPTIMIZATION_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS,
      { delivery_optimization: DeliveryOptimizationConfigApiFields }
    >

export type UpdateDeliveryOptimizationResolvedAction =
  | AxiosAction<typeof UPDATE_DELIVERY_OPTIMIZATION_CONFIG>
  | FailureAction<typeof UPDATE_DELIVERY_OPTIMIZATION_CONFIG_FAIL>
  | SuccessAction<
      typeof UPDATE_DELIVERY_OPTIMIZATION_CONFIG_SUCCESS,
      { delivery_optimization: DeliveryOptimizationConfigApiFields }
    >

export type GetOrderingMerchantConfigResolvedAction =
  | FailureAction<typeof GET_ORDERING_MERCHANT_CONFIG_FAIL>
  | SuccessAction<
      typeof GET_ORDERING_MERCHANT_CONFIG_SUCCESS,
      { ordering_config: OrderingConfigApiFields }
    >

export type UpdateOrderingMerchantConfigResolvedAction =
  | AxiosAction<typeof UPDATE_ORDERING_MERCHANT_CONFIG>
  | FailureAction<typeof UPDATE_ORDERING_MERCHANT_CONFIG_FAIL>
  | SuccessAction<
      typeof UPDATE_ORDERING_MERCHANT_CONFIG_SUCCESS,
      { ordering_config: OrderingConfigApiFields }
    >

export function getReceiptConfig(): AxiosAction<
  typeof GET_RECEIPT_CONFIG,
  { receipt_config: ReceiptConfigApiFields }
> {
  return {
    type: GET_RECEIPT_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'receipt_config',
        method: 'get',
      },
    },
  }
}

export function updateReceiptConfig(
  receiptConfig: Partial<ReceiptConfigApiFields>
): AxiosAction<typeof UPDATE_RECEIPT_CONFIG> {
  return {
    type: UPDATE_RECEIPT_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'receipt_config',
        method: 'patch',
        data: {
          receipt_config: receiptConfig,
        },
      },
    },
  }
}

export function getTiersConfig(): AxiosAction<
  typeof GET_TIERS_CONFIG,
  { tiers_config: TiersConfigApiFields | null }
> {
  return {
    type: GET_TIERS_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'tiers_config',
        method: 'get',
      },
    },
  }
}

export function getAnalytics(): AxiosAction<typeof GET_ANALYTICS_CONFIG> {
  return {
    type: GET_ANALYTICS_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'ordering_analytics',
        method: 'get',
      },
    },
  }
}

export function updateAnalytics(
  analytics: object
): AxiosAction<typeof UPDATE_ANALYTICS_CONFIG> {
  return {
    type: UPDATE_ANALYTICS_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'ordering_analytics',
        method: 'patch',
        data: {
          ordering_analytics: analytics,
        },
      },
    },
  }
}

export function getPreferencesModalSetting(): AxiosAction<
  typeof GET_PREFERENCES_MODAL_CONFIG
> {
  return {
    type: GET_PREFERENCES_MODAL_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'preferences_modal',
        method: 'get',
      },
    },
  }
}

export function updatePreferencesModalSetting(
  setting: string,
  appSetting?: string
): AxiosAction<typeof UPDATE_PREFERENCES_MODAL_CONFIG> {
  return {
    type: UPDATE_PREFERENCES_MODAL_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'preferences_modal',
        method: 'put',
        data: { preferences_modal: { setting, app_setting: appSetting } },
      },
    },
  }
}

export function getDeliveryOptimizationSetting(): AxiosAction<
  typeof GET_DELIVERY_OPTIMIZATION_CONFIG
> {
  return {
    type: GET_DELIVERY_OPTIMIZATION_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'delivery_optimization',
        method: 'get',
      },
    },
  }
}

export function updateDeliveryOptimizationSetting(
  setting: DeliveryOptimizationSetting
): AxiosAction<typeof UPDATE_DELIVERY_OPTIMIZATION_CONFIG> {
  return {
    type: UPDATE_DELIVERY_OPTIMIZATION_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'delivery_optimization',
        method: 'put',
        data: { delivery_optimization: { setting } },
      },
    },
  }
}

export function getOrderingMerchantConfig(): AxiosAction<
  typeof GET_ORDERING_MERCHANT_CONFIG
> {
  return {
    type: GET_ORDERING_MERCHANT_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'ordering_config',
        method: 'get',
      },
    },
  }
}

export function updateOrderingMerchantConfig(
  unavailableItemVisibility: UnavailableItemVisibilitySetting
): AxiosAction<typeof UPDATE_ORDERING_MERCHANT_CONFIG> {
  return {
    type: UPDATE_ORDERING_MERCHANT_CONFIG,
    payload: {
      client: 'default',
      request: {
        url: 'ordering_config',
        method: 'patch',
        data: {
          ordering_config: {
            unavailable_item_visibility: unavailableItemVisibility,
          },
        },
      },
    },
  }
}

export type ResolvedAction =
  | GetReceiptConfigResolvedAction
  | GetTiersConfigResolvedAction
  | GetAnalyticsResolvedAction
  | UpdateAnalyticsResolvedAction
  | GetPreferencesModalResolvedAction
  | UpdatePreferencesModalResolvedAction
  | GetDeliveryOptimizationResolvedAction
  | UpdateDeliveryOptimizationResolvedAction
  | GetOrderingMerchantConfigResolvedAction
  | UpdateOrderingMerchantConfigResolvedAction
